/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/no-array-index-key */
/* eslint-disable import/no-unresolved */
import {
    Select, SelectOption, Breadcrumb,
} from 'appkit-react';
import { Row, Col } from 'react-bootstrap';

import Loader from 'views/Shared/components/Loader';
import QuarterSelectModalContainer from '../containers/QuarterSelectModalContainer';
import MDRMCommonalityContainer from '../containers/MDRMCommonalityContainer';
import ReportItemCodeContainer from '../containers/ReportItemCodeContainer';
import DataSourceModalContainer from '../containers/DataSourceModalContainer';
import '../styles/index.scss';

const containerStyle = { display: 'flex', alignItems: 'center' };
const spanStyle = {
    marginLeft: '5px',
    paddingLeft: '5px',
    fontSize: '10px',
    color: '#D04A02',
    fontStyle: 'italic',
    textAlign: 'right',
};

/**
    * @param selectionName as recommended column name
    * @returns div component for each selection option where column name matches recommended column name
    */
const getBadge = (selectionName, badgeText, badgeQuarterText) => (
    <div style={containerStyle}>
        {selectionName}
        {badgeQuarterText && (<span style={spanStyle}>{badgeQuarterText}</span>)}
        <span className="risk-detect-reg-reporting-cross-report_column-2_crossreport_select">
            {badgeText}
        </span>
    </div>
);

/**
     * @returns select options for source column
     */
const crossReportsSelectOptions = (reportList, selectedCrossReportsArray, onCrossReportSelection) => reportList && reportList.map(({
    id, name, hasPeriod, periodData, dataSource, commonMdrm,
}) => {
    const selectedReport = selectedCrossReportsArray.filter(scr => scr.id === id)[0];
    const badgeText = `Common MDRM: ${commonMdrm}`;
    let badgeQuarterText = '';
    if (selectedReport && selectedReport.quarters) {
        badgeQuarterText = selectedReport.quarters.map(q => q.label).join(',');
    }
    return (
        <SelectOption
            key={id}
            value={id}
            disabled={!dataSource}
            onClick={() => {
                if (hasPeriod) {
                    onCrossReportSelection(id, name, commonMdrm, periodData);
                } else {
                    onCrossReportSelection(id, name, commonMdrm);
                }
            }}
        >
            {getBadge(name, badgeText, badgeQuarterText)}
        </SelectOption>
    );
});

const CrossReportValidation = ({
    reportList, breadcrumbItems, setPrimaryReportId, primaryReportId,
    crossValidatedReports, setCrossValidatedReports, showPrimaryPeriodSelect,
    primaryPeriodOptions, primaryReportPeriod, setPrimaryReportPeriod,
    onCrossReportSelection, showPeriodSelectModal, setShowPeriodSelectModal,
    selectedCrossReport, periodSelectOptions, onCrossReportQuarterSelection, loading,
    selectedCrossReportsArray, crossReportList, primaryReport, relatedReports,
    selectedPrimaryReport, showDataSourceModal, onConfigureDataSource,
}) => (
    <div>
        <div className="risk-detect-reg-reporting-cross-report_layout">
            <div className="risk-detect-reg-reporting-cross-report_column-2">
                <Breadcrumb items={breadcrumbItems} />
                {loading && <Loader />}
                {!loading && (
                    <>
                        <Row>
                            <Col md={2}>
                                <label className="a-panel-title">
                                    PRIMARY REPORT
                                </label>
                                <Select
                                    value={primaryReportId}
                                    placeholder="Select Report"
                                    showSearchOnList
                                    onSelect={value => {
                                        setPrimaryReportId(value);
                                    }}
                                >
                                    {
                                        reportList && reportList.map(({ id, name, dataSource }) => (
                                            <SelectOption key={id} value={id} disabled={!dataSource}>{name}</SelectOption>
                                        ))
                                    }
                                </Select>
                            </Col>
                            {showPrimaryPeriodSelect && (
                                <Col md={2}>
                                    <label className="a-panel-title">
                                        REPORT PERIOD
                                    </label>
                                    <Select
                                        value={primaryReportPeriod}
                                        placeholder="Select Period"
                                        onSelect={value => {
                                            setPrimaryReportPeriod(value);
                                        }}
                                    >
                                        {
                                            primaryPeriodOptions && primaryPeriodOptions.map(({ label, period, dataSource }) => (
                                                <SelectOption key={period} value={period} disabled={!dataSource}>{label}</SelectOption>
                                            ))
                                        }
                                    </Select>
                                </Col>
                            )}
                            {crossReportList.length > 0 && (
                                <Col md={3}>
                                    <label className="a-panel-title">
                                        CROSS VALIDATION REPORTS
                                    </label>
                                    {showPeriodSelectModal && (
                                        <QuarterSelectModalContainer
                                            showPeriodSelectModal={showPeriodSelectModal}
                                            setShowPeriodSelectModal={setShowPeriodSelectModal}
                                            selectedCrossReport={selectedCrossReport}
                                            periodData={periodSelectOptions}
                                            onCrossReportQuarterSelection={onCrossReportQuarterSelection}
                                        />
                                    )}
                                    <Select
                                        value={crossValidatedReports}
                                        multiple
                                        placeholder="Select Cross Validation Reports"
                                        showSearchOnList
                                        onSelect={value => {
                                            setCrossValidatedReports(value);
                                        }}
                                    >
                                        {crossReportsSelectOptions(crossReportList, selectedCrossReportsArray, onCrossReportSelection)}
                                    </Select>
                                </Col>
                            )}
                        </Row>
                        <Row>
                            <Col>
                                <MDRMCommonalityContainer
                                    primaryReport={primaryReport}
                                    relatedReports={relatedReports}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <ReportItemCodeContainer
                                    selectedPrimaryReport={selectedPrimaryReport}
                                    selectedCrossReportsArray={selectedCrossReportsArray}
                                />
                            </Col>
                        </Row>
                    </>
                )}
            </div>
            {showDataSourceModal && reportList.length > 0 && (
                <DataSourceModalContainer
                    showDataSourceModal={showDataSourceModal}
                    reportList={reportList}
                />
            )}
        </div>
    </div>
);

export default CrossReportValidation;
